import script from "./ViewLimitModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewLimitModal.vue?vue&type=script&setup=true&lang=js"

import "./ViewLimitModal.vue?vue&type=style&index=0&id=5473e14d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5473e14d"]])

export default __exports__